import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { reglagePieces, reglageServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import ContactForm from "@/pages/home/components/ContactForm";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Hero from "./components/Hero";
import WhyDerails from "./components/WhyDerails";
import HowWeFix from "./components/HowWeFix";
import AllBrands from "./components/AllBrands";
import RepairNotReplace from "./components/RepairNotReplace";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import InternalLinks from "./components/InternalLinks";
import FloatingButton from "./components/FloatingButton";

export default function ReglageOscilloBattant() {
  useSEO(seoData.reglageOscilloBattant);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...reglagePieces} />
        <ServicesSection {...reglageServices} />
        <WhyDerails />
        <HowWeFix />
        <AllBrands />
        <RepairNotReplace />
        <FAQ />
        <Gallery />
        <InternalLinks />
        <GoogleReviews />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}